import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

const CalendarService = {
  removeStaleOauth: (payload: any) =>
    requests(SERVICE_NAME.AUTOMATION_CALENDARS_API).post(
      "remove-stale-oauth",
      payload
    ),
};

export default CalendarService;
